import React from 'react';
import { IMG_SPIN } from '@assets';
import styled from 'styled-components';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
width: 100vw;
max-width: 480px;
position: fixed;
left: auto;
bottom: 0;
z-index: 1000;
`;

const Icon = styled.img.attrs({
    alt: 'spin-icon',
    src: IMG_SPIN,
})`
width: 75px;
position: absolute;
bottom: 70px;
right: 20px;
cursor: pointer;
z-index: 1000;
`;

const Spin = () => {
    const navigate = useNavigate();

    const handleClicked = () => {
        navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
    }

    return (
        <Container>
            <Icon onClick={handleClicked} />
        </Container>
    );
}

export default Spin;